export const GOOGLE_DRIVE_CONSTANTS = {
  // API Configuration
  CLIENT_ID: '907434411868-ggbhd50p7tf7lkd5s50n110cn7im1bdi.apps.googleusercontent.com',
  API_KEY: 'AIzaSyCwThvKCv_lRZF6UNiduW-y5J15HPT7RzQ',
  DISCOVERY_DOC: 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
  SCOPES: 'https://www.googleapis.com/auth/drive.readonly',

  // GAPI Configuration
  GAPI_CLIENT: 'client',

  // API Endpoints
  DRIVE_FILES_ENDPOINT: 'https://www.googleapis.com/drive/v3/files',

  // Query Parameters
  QUERY_PDF_ONLY: "mimeType='application/pdf'",
  ALT_MEDIA: 'media',

  // Field Selections
  FILE_LIST_FIELDS:
    'nextPageToken, files(id, name, mimeType, size, modifiedTime, thumbnailLink)',
  FILE_METADATA_FIELDS: 'name,mimeType,size',

  // Pagination
  DEFAULT_PAGE_SIZE: 40,

  // HTTP Methods
  HTTP_GET: 'GET',

  // MIME Types
  MIME_TYPE_PDF: 'application/pdf',

  // Prompt Types
  PROMPT_CONSENT: 'consent',
  PROMPT_EMPTY: '',

  // Data URL Prefixes
  DATA_URL_PREFIX: 'data:',
  PDF_HEADER: '%PDF',

  // Error Messages
  ERROR_EMPTY_DATA: 'Downloaded data is empty',
  ERROR_DOWNLOAD_FAILED: 'Download failed',
  ERROR_FILE_READER_NULL: 'FileReader returned null result',
  ERROR_INVALID_DATA_URL: 'Invalid data URL format',
  ERROR_INVALID_PDF_BASE64: 'Invalid PDF base64 data',
  ERROR_INVALID_PDF_FORMAT: 'Invalid PDF file format',
  ERROR_INVALID_BASE64: 'Invalid base64 encoding',
  ERROR_FILE_READER: 'FileReader error',
  ERROR_UNKNOWN: 'Unknown error',

  // Validation Thresholds
  MIN_PDF_BASE64_LENGTH: 100,
  PDF_HEADER_CHECK_LENGTH: 20,

  // Retry Configuration
  GAPI_INIT_RETRY_DELAY: 100,

  // Token Configuration
  AUTHORIZATION_HEADER: 'Authorization',
  BEARER_PREFIX: 'Bearer',
};
